import T from 'prop-types'

export default {
  /**
   * Unique key for the column.
   */
  key: T.string.isRequired,

  /**
   * Content of the column header cell.
   */
  header: T.node,

  /**
   * Optional simple text label for the column, used in places where a simple text label is
   * needed, if `header` is rich content. Falls back to the value of `header`.
   */
  headerText: T.string,

  /**
   * Custom function to render an individual data column's header.
   * If not specified, defaults to `dataItem.header]`
   */
  renderHeader: T.func, //(cellProps)

  /**
   * Optional tooltip to be shown for the column header cell.
   */
  headerTooltip: T.string,

  /**
   * Optional className to be applied to the column header cell.
   */
  headerClass: T.string,

  /**
   * Width of the column in pixels. Cell contents will be truncated if necessary.
   * Defaults to the width of the column header cell's content.
   */
  width: T.number,

  /**
   * Whether the column can be drag-resized.
   */
  resizable: T.bool,

  /**
   * Whether the column can be sorted.
   */
  sortable: T.bool,

  /**
   * Whether the column should be fixed to the left-hand edge of the scroll area. Fixed columns
   * can not be reordered or hidden and will always be shown as the leftmost columns.
   */
  fixed: T.bool,

  /**
   * The initial sort direction to use when sorting this column if it is not already sorted.
   * Defaults to 'asc'.
   */
  initialSortDir: T.oneOf(['asc', 'desc']),

  /**
   * Custom function to render an individual data cell's content.
   * If not specified, defaults to `dataItem => dataItem[column.key]`
   * - Optional cellProps object may be passed from the parent DataTable.
   */
  renderValue: T.func, //(dataItem, rowIndex, colIndex, cellProps)

  /**
   * Generate a custom className for an individual data cell.
   */
  getCellClass: T.func //(dataItem, rowIndex, colIndex),
}
